import { useMutation, useQueryClient, type QueryKey } from "@tanstack/react-query";
import { useCampaignEdited } from "./useCampaignEdited";

/**
 * Every write below a campaign refreshes the list it changed and the campaign
 * itself, so the publish prompt appears without a reload. Hooks name the keys
 * they invalidate; nothing else about the wrapper varies per resource.
 */
export const useCampaignMutation = <TVariables>(
	campaignId: string,
	invalidates: readonly QueryKey[],
	run: (variables: TVariables) => Promise<unknown>,
) => {
	const queryClient = useQueryClient();
	const campaignEdited = useCampaignEdited(campaignId);
	return useMutation({
		mutationFn: run,
		onSuccess: () => {
			for (const queryKey of invalidates) void queryClient.invalidateQueries({ queryKey });
			campaignEdited();
		},
	});
};
